import { useEffect, useState } from "react";
import { Popup } from "semantic-ui-react";
import { isMobile } from "@hudson/ui/lib/utils";
import Content from "./index";
import useContent from "@lib/use_content";

interface PopupParams {
  subfares?: be.FieldValue[];
}

export default function SubfarePopup({ subfares }: PopupParams) {
  const [showPopup, setShowPopup] = useState(false);
  const { data, loading, error } = useContent([
    "beWebSubfareACaption",
    "beWebSubfareBCaption",
    "beWebSubfareCCaption",
    "beWebSubfareDCaption",
    "beWebSubfareECaption",
  ]);

  useEffect(() => {
    if (loading || !data?.content) return;
    if (subfares?.some((sf) => data.content[`beWebSubfare${sf.field.toUpperCase()}Caption`]))
      setShowPopup(true);
  }, [loading]);

  return (
    showPopup && (
      <Popup
        basic
        popperModifiers={[{ name: "preventOverflow", options: { tether: false, padding: 5 } }]}
        position="top right"
        positionFixed={true}
        wide={!isMobile()}
        trigger={
          <div className="flex items-center items-start relative -top-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6 ml-1.5 cursor-pointer"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
          </div>
        }
      >
        <div className="px-1 py-1">
          <Content subfares={subfares} />
        </div>
      </Popup>
    )
  );
}
